export default __webpack_public_path__ + "static/media/huma-hyperchaotic-01.609c8859.jpg";